<template>
  <div>
    <BoxDetails
      :should-add-event-schema="true"
      :event-permalink="$route.params.boxPermalink.toString()"
    ></BoxDetails>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  allowOnPartnerPage: true,
  layout: 'default-max-screen',
  contentGroup: 'box',
  preloaderType: 'eventDetail',
})
</script>
